import React from 'react'
import { oneOf, string, func } from 'prop-types'

import { MenuItem } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import Keyword from './Keyword'

function Suggestion({
  type,
  keyword = '',
  categoryTitle = '',
  itemTitle = '',
  itemThumbnailImage = '',
  searchKeyword = '',
  onKeywordClick = null,
  suggestedKeyword = '',
  thumbnailUrl = '',
}) {
  switch (type) {
    case 'keywordsInCategory':
      return (
        <li
          className="new-search__suggestion"
          data-track="search-suggestion-click"
          data-suggestion-type="keyword-in-category"
          data-selected-keyword={keyword}
          data-content-type="search-suggestion"
        >
          <MenuItem label={`${keyword} in ${categoryTitle}`} fluid />
        </li>
      )
    case 'category':
      return (
        <Keyword
          {...{
            suggestedKeyword,
            searchKeyword,
            onKeywordClick,
            thumbnailUrl,
          }}
        />
      )
    case 'item':
      return (
        <li
          className="new-search__suggestion"
          data-track="search-suggestion-click"
          data-suggestion-type="item"
          data-selected-keyword={itemTitle}
          data-content-type="search-suggestion"
        >
          <img
            src={itemThumbnailImage}
            alt={itemTitle}
            width={60}
            height={40}
          />
          <MenuItem label={`${itemTitle}`} fluid />
        </li>
      )
    default:
      return null
  }
}

Suggestion.propTypes = {
  type: oneOf(['keywordsInCategory', 'category', 'item']).isRequired,
  keyword: string,
  categoryTitle: string,
  itemTitle: string,
  itemThumbnailImage: string,
  searchKeyword: string,
  thumbnailUrl: string,
  onKeywordClick: func,
  suggestedKeyword: string,
}

export default Suggestion
